<!-- 团餐客户退货未审批列表  退货凭证-->
<template>
  <div>
    <el-row>
      <el-col :span="3" style="margin-top:20px" v-for="(item, index) in tableData" :key="index">
        <el-card :body-style="{ padding: '0px' }" style="margin-left:10px">
          <img :src="item.FILE_URL" class="image" style="height:200px">
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <el-button size="medium" type="text" class="button" @click="openImage(item.FILE_URL)">查看大图</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <img :src="this.imgUrl" style="width:100%">
    </el-dialog>
  </div>
</template>
<script>
import { queryReturnDetailFun } from 'api/returnCheck';

export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      imgUrl: '',
    };
  },
  methods: {
    // -----------------------------进入拉取数据
    queryContract() {
      const data = {
        DETAIL_ID: Number(sessionStorage.getItem('orderId')),
      };
      queryReturnDetailFun(data)
        .then((result) => {
          this.RETURN_ID = result[0].RETURN_ID;
          this.STATUS = result[0].STATUS;
          if (result[0].FILES.length !== 0) {
            this.tableData = result[0].FILES;
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openImage(e) {
      this.dialogVisible = true;
      this.imgUrl = e;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
  created() {
    this.queryContract();
  },
};
</script>
<style>
.image {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/audit/checkDetail.vue